import {
  get,
  union,
} from 'lodash'

import { getUUIDv4 } from '@/src/utils/helper'
import { convertLinkToBackEnd } from '@/src/utils/url'
import { createMapboxImageUrl } from '@components/Map/helper'

import { LAYER_TYPE } from '../layer'
import { ALayer } from './ALayer'

const SOURCE = {}
function createSource(url, select = []) {
  return `${url}?s=${select.join(',')}`
}
export class NbdsVectorLayer extends ALayer {
  get layer_ids() {
    return this.layers.map((x) => x.id)
  }
  constructor(options) {
    let info = options.info
    super({
      metadata: {
        bounds: info.bounds,
        fields: get(info, 'datastore_detail.fields', []),
      },
      type: 'circle',
    })
    this.url = convertLinkToBackEnd(info.tile_link)
    this.layerId = `layer-${getUUIDv4()}`
    this.sourceId = `source-${info.tile_link}`
    let { layers, fields, image_ids } = convertNbdsStyleToMapBoxStyle(
      info.style
    )
    this.image_ids = image_ids
    this.image_urls =  this.image_ids.map(id=> convertLinkToBackEnd(`api/image/${id}.png`))
    if (!SOURCE[this.url]) {
      SOURCE[this.url] = { fields: [] }
    }
    SOURCE[this.url].fields = union(SOURCE[this.url].fields, fields)
    this.source = {
      tiles: [createSource(this.url, SOURCE[this.url].fields)],
      type: 'vector',
      bounds: info.bounds || [-180, -85.051129, 180, 85.051129],
    }
    this.info = info
    this.layers = layers
  }
  convertDefaultView(layer_view) {}
  getStyle() {
    return this.layers[0]
  }
  getBeforeId() {
    return this.layers[this.layers.length - 1].id
  }
  async addToMap(map) {
    if (!map.getSource(this.sourceId)) {
      map.addSource(this.sourceId, this.source)
    }
    if (this.image_ids && this.image_ids.length > 0) {
      await Promise.all(
        this.image_ids.map((id) =>
          createMapboxImageUrl(
            map.id,
            '_custom_image_' + id,
            convertLinkToBackEnd(`api/image/${id}.png`)
          )
        )
      )
    }
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      layer.id = layer_id
      if (!map.getLayer(layer_id)) {
        let temp = {
          ...layer,
          id: layer_id,
          'source-layer': 'tile-server',
          source: this.sourceId,
          metadata: {
            layer_type: LAYER_TYPE.NBDS_VECTO_LAYER,
            layer_id: this.info.id,
          },
        }
        layer = temp
        map.addLayer(temp)
      }
    })
  }
  removeFromMap(map) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`

      if (map.getLayer(layer_id)) {
        map.removeLayer(layer_id)
      }
    })
    if (this.layer_label && map.getLayer(this.layer_label.id)) {
      map.removeLayer(this.layer_label.id)
    }
    if (map.getSource(this.sourceId)) {
      map.removeSource(this.sourceId)
    }
  }
  moveLayer(map, beforeId) {
    let temp_before_id = beforeId
    let layers = [...this.layers]
    if (this.layer_label && this.layer_label.id) {
      layers.push(this.layer_label)
    }
    layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      map.moveLayer(layer_id, temp_before_id)
      temp_before_id = layer_id
    })
  }
  toggleShow(map, show) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      map.setLayoutProperty(layer_id, 'visibility', show ? 'visible' : 'none')
    })
  }
  setOpacity(map, opacity) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      let keyOpacity = `${layer.type}-opacity`
      map.setPaintProperty(layer_id, keyOpacity, opacity)
    })
  }
  setStyle(map, style) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      if (map.getLayer(layer_id)) {
        map.removeLayer(layer_id)
      }
    })
    let { layers, fields, image_ids } = convertNbdsStyleToMapBoxStyle(style)
    SOURCE[this.url].fields = union(SOURCE[this.url].fields, fields)
    this.image_ids = image_ids
    this.layers = layers

    if (this.layers[0] && this.layers[0].filter && this.layer_label) {
      this.layer_label.filter = this.layers[0].filter
      map.setFilter(this.layer_label.id, this.layer_label.filter)
    }
    this.resetSource(map)
    this.addToMap(map)
  }
  resetSource(map) {
    map
      .getSource(this.sourceId)
      .setTiles([createSource(this.url, SOURCE[this.url].fields)])
  }
  showLabel(map, show) {
    if (!this.layer_label) {
      switch (this.info.type) {
        case 'Point':
        case 'MultiPoint':
          this.layer_label = {
            type: 'symbol',
            layout: {
              'text-field': ['get', 'name'],
              'text-size': 16,
              'text-offset': [0, 1],
              'text-ignore-placement':true
            },
            paint: {
              'text-color': '#333',
              'text-halo-color': 'hsl(0, 0%, 100%)',
              'text-halo-width': 1.5,
              'text-halo-blur': 1,
            },
          }
          break
        case 'LineString':
        case 'MultiLineString':
          this.layer_label = {
            type: 'symbol',
            layout: {
              'symbol-placement': 'line',
              'text-field': ['get', 'name'],
              'text-size': 16,
            },
            paint: {
              'text-color': '#333',
              'text-halo-color': 'hsl(0, 0%, 100%)',
              'text-halo-width': 1.5,
              'text-halo-blur': 1,
            },
          }
          break

        default:
          this.layer_label = {
            type: 'symbol',
            layout: {
              'text-field': ['get', 'name'],
              'text-size': 16,
            },
            paint: {
              'text-color': '#333',
              'text-halo-color': 'hsl(0, 0%, 100%)',
              'text-halo-width': 1.5,
              'text-halo-blur': 1,
            },
          }
          break
      }
      this.layer_label.minzoom = 8
      this.layer_label.id = `${this.layerId}-label`
      this.layer_label['source-layer'] = 'tile-server'
      this.layer_label['source'] = this.sourceId
      if (this.layers[0] && this.layers[0].filter) {
        this.layer_label.filter = this.layers[0].filter
      }
    }
    if (!map.getLayer(this.layer_label.id)) {
      map.addLayer(this.layer_label)
    }
    if (this.layer_label) {
      map.setFilter(this.layer_label.id, this.layer_label.filter)
    }
    map.setLayoutProperty(
      this.layer_label.id,
      'visibility',
      show ? 'visible' : 'none'
    )
  }
}
function convertNbdsStyleToMapBoxStyle(style) {
  let layers = []
  let content = style.content
  let fields = []
  let image_ids = []
  layers = content.map((x) => {
    let style = x.style
    let icon = style.icon
    let temp = {}
    switch (x.type) {
      case 'Point':
        if (icon['icon_type'] == 'shape') {
          temp = {
            type: 'circle',
            paint: {
              'circle-radius': +(style['size'] ?? 5),
              'circle-color': icon['fill'] ?? '#000',
              'circle-opacity': +(icon['fill-opacity'] ?? 1),
            },
          }
          if (icon['use_stroke']) {
            temp['paint']['circle-stroke-width'] = +(icon['stroke-width'] ?? 1)
            temp['paint']['circle-stroke-opacity'] = +(
              icon['stroke-opacity'] ?? 1
            )
            temp['paint']['circle-stroke-color'] = icon['stroke'] ?? '#000'
          }
        } else if (icon['icon_type'] == 'image') {
          temp = {
            type: 'symbol',
            layout: {
              'icon-image': '_custom_image_' + icon['image_id'],
              'icon-size': +(style['size'] ?? 1),
            },
            paint: {
              'icon-opacity': +(style['opacity'] ?? 1),
            },
          }
          image_ids.push(icon['image_id'])
        }
        break
      case 'Line':
        temp = {
          type: 'line',
          paint: {
            'line-width': +(style['stroke-width'] ?? 5),
            'line-color': style['stroke'] ?? '#000000',
            'line-opacity': +(style['stroke-opacity'] ?? 1),
          },
          layout:{}
        }
        if(style['stroke-dasharray']){
          temp['paint']['line-dasharray']=style['stroke-dasharray']
        }
        if(style['line-join']){
          temp['layout']['line-join']=style['line-join']
        }
        if(style['line-cap']){
          temp['layout']['line-cap']=style['line-cap']
        }
        break
      case 'Polygon':
        temp = {
          type: 'fill',
          paint: {
            'fill-color': style['fill'] ?? '#000000',
            'fill-opacity': +(style['fill-opacity'] ?? 1),
          },
        }
        if (style['use_stroke']) {
          temp['paint']['fill-outline-color'] = style['stroke'] ?? '#000'
        }
        break
    }
    let rules = x.rules
    if (rules && rules.length > 0) {
      temp['filter'] = [
        'all',
        ...rules.map((x) => {
          let opt = x.opt
          if (opt == '=') {
            opt = '=='
          }
          if (!fields.includes(x.first)) fields.push(x.first)
          return [opt, x.first, x.second]
        }),
      ]
    }
    return temp
  })
  return { layers, fields, image_ids }
}
